export interface UseNewTosModalReturn {
    shouldShowNewTosModal: ComputedRef<boolean>;
    isProcessing: Ref<boolean>;
    acceptNewTos: () => Promise<void>;
}

export const useNewTosModal = () => {
    const authStore = useAuthStore();
    const isProcessing = ref(false);

    const shouldShowNewTosModal = computed(() => {
        return authStore.user?.notifyAboutUpcomingTosVersion;
    });

    const acceptNewTos = async () => {
        if (isProcessing.value) return;

        isProcessing.value = true;
        try {
            await authStore.acceptNewTos(true);
        } finally {
            isProcessing.value = false;
        }
    };

    return {
        shouldShowNewTosModal,
        isProcessing,
        acceptNewTos,
    };
};
